var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator7 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26 5H6v26h20V5ZM6 9h20M6 27h20",
  stroke: "#1BB169",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m17 14-3 4h4l-3 4M8 1h4M20 1h4",
  stroke: "#1BB169",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})));
export default SvgIndicator7;